<sh-card headerText="Bankdaten bearbeiten" i18n-headerText>
  @if (success$ | async) {
    <sh-info-text
      severity="success"
      text="Vielen Dank. Die Änderung Ihrer Bankdaten wurde zur Prüfung an Transgourmet Österreich GmbH weitergeleitet"
      i18n-text
    ></sh-info-text>
  }

  @if ((success$ | async) !== true) {
    <sh-info-text
      severity="error"
      text="Ihr Link hat seine Gültigkeit verloren"
      i18n-text
    ></sh-info-text>
  }

  <div class="col-12 button-bar">
    <p-button label="zurück" i18n-label [routerLink]="['/']"></p-button>
  </div>
</sh-card>
